export default function LoadingStep() {
  return (
    <div className="flex h-full flex-col items-center justify-center space-y-6 text-center">
      {/* Loading Icon */}
      <div className="flex justify-center">
        <div
          className="animate-spin rounded-full"
          style={{
            width: '48px',
            height: '48px',
            border: '4px solid transparent',
            borderTop: '4px solid #2563eb',
            borderRight: '4px solid #2563eb',
            borderBottom: '4px solid #2563eb',
          }}
        ></div>
      </div>

      {/* Loading Text */}
      <p className="font-bold text-blue-600">読み込み中...</p>
    </div>
  );
}
